import styled, { css } from 'styled-components'
import { mobile, tablet } from '../../constants/breakpoints'

export const Page = styled.div`
  width: 100%;
  min-height: calc(100vh - 72px);
  margin: 72px auto 0 auto;
  background: #f8fcff;
  padding-top: 50px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: calc(${tablet})) {
    margin-top: 20px;
    padding-top: 72px;
  }

  @media (max-width: calc(${mobile})) {
    display: none;
  }
`

export const ContentWrap = styled.div`
  background-color: #fff;
  border-radius: 30px;
  border: 1px solid #b7bdc6;
  width: 100%;
  max-width: 742px;
  padding: 50px 60px;

  @media (max-width: calc(${tablet})) {
    border: none;
    padding: 20px 30px;
    background: #f8fcff;
  }

  h1 {
    color: #4c5197;
    text-align: center;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0 0 20px 0;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Footer = styled.div<{ $disabled?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;

  button,
  a {
    user-select: none;
    text-decoration: none;
    outline: none;
    border: none;
    display: flex;
    width: 250px;
    height: 48px;
    min-width: 136px;
    padding: 4px 0px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    background: linear-gradient(90deg, #d587df 0%, #a25ee1 100%);
    color: var(--Button-Primary-text, #fff);
    text-align: center;

    /* Paragraph 3 - Medium */
    font-family: Inter;
    font-size: var(--Fonts-Size-Paragraph-3, 16px);
    font-style: normal;
    font-weight: 500;
    line-height: var(--Fonts-Line-height-Paragraph-3, 24px); /* 150% */
    letter-spacing: -0.16px;

    transition: box-shadow 0.2s ease-out, filter 0.2s ease-out;

    &:hover {
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
      cursor: pointer;
    }

    &:disabled {
      filter: grayscale();
    }

    &:hover:disabled {
      cursor: default;
      box-shadow: none;
    }

    ${({ $disabled }) =>
      $disabled &&
      css`
        filter: grayscale();
        pointer-events: none;
        cursor: default;
        &:hover {
          cursor: default;
          box-shadow: none;
        }
      `}
  }

  @media (max-width: calc(${mobile})) {
    position: fixed;
    bottom: 48px;
    left: 0px;
    width: 100%;

    display: flex;
    justify-content: center;
  }
`

export const StepLine = styled.div`
  width: 100%;
  height: 62px;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0px 24px;
  margin-bottom: 10px;

  div {
    display: flex;
    width: 46px;
    height: 46px;
    padding: 4px 0px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    background: linear-gradient(90deg, #d587df 0%, #a25ee1 100%);
    color: #fff;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: var(--Fonts-Line-height-Paragraph-3, 24px); /* 133.333% */
    letter-spacing: -0.18px;
  }

  span {
    color: #4c5197;
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  @media (max-width: calc(${mobile})) {
    height: 90px;

    align-items: center;
    justify-content: flex-start;
    margin-bottom: 8px;

    span {
      text-align: left;
    }
  }
`

export const PageMobile = styled.div`
  width: 100%;
  min-height: 100dvh;
  background: #fff;

  @media (min-width: calc(${mobile} + 1px)) {
    display: none;
  }

  padding: 50px 30px 30px 30px;
`

export const TitleMobile = styled.h1`
  color: #4c5197;
  text-align: center;
  font-family: Poppins;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`
